import classNames from 'classnames';
import React from 'react';

import ParameterComponent from 'sharedreact/components/ParameterComponent';
import ParameterGroupProvider from 'sharedreact/components/private/ParameterGroupProvider';

type Props = {
  className?: string;
  title?: string;
  children?: React.ReactNode;
  useProvider?: boolean;
  minLabelWidth?: number;
};

function ParameterSet ({className, title, children, useProvider = true, minLabelWidth}: Props) {
  if (useProvider) {
    return (
      <ParameterGroupProvider minLabelWidth={minLabelWidth}>
        <div
          className={classNames(
            className,
            'esko_form-horizontal',
            'esko_parameterset'
          )}
        >
          {title != null ? <ParameterComponent label=' '><h3>{title}</h3></ParameterComponent> : null}
          {children}
        </div>
      </ParameterGroupProvider>
    );
  } else {
    return (
      <div
        className={classNames(
          className,
          'esko_form-horizontal',
          'esko_parameterset'
        )}
      >
        {title != null ? <ParameterComponent label=' '><h3>{title}</h3></ParameterComponent> : null}
        {children}
      </div>
    );
  }
}



export { 
  ParameterGroupProvider
};

export default ParameterSet;
